import { render, staticRenderFns } from "./new-detailed.vue?vue&type=template&id=96e2c1dc&scoped=true"
import script from "./new-detailed.vue?vue&type=script&lang=js"
export * from "./new-detailed.vue?vue&type=script&lang=js"
import style0 from "./new-detailed.vue?vue&type=style&index=0&id=96e2c1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e2c1dc",
  null
  
)

export default component.exports